// extracted by mini-css-extract-plugin
export default {"wrapper":"OfferTypeCard_wrapper__bNGsj","newVehicle":"OfferTypeCard_newVehicle__cE7Ke","service":"OfferTypeCard_service__4ZLMt","usedVehicle":"OfferTypeCard_usedVehicle__-199Y"};